// ToDo: Move groups into src/js/helper/bike-attributes.js SPEC_GROUPS
export const compareProductGroupConfig = {
  EbikeBatteryName_ItemBatteryAmpHours: {
    target: 'ItemBatterySpec',
    fields: ['EbikeBatteryName', 'ItemBatteryAmpHours'],
  },
  ItemFrameSizeCode_ItemFrameSizeCm: {
    target: 'SpecFrameSize',
    fields: ['ItemFrameSizeCode', 'ItemFrameSizeCm'],
  },
  ItemTireDescription_ItemTireRearDescription: {
    target: 'ItemTireDescription',
    fields: ['ItemTireDescription', 'ItemTireRearDescription'],
  },
  ProductGroupset_ProductGearSystemDescription: {
    target: 'SpecGroupset',
    fields: ['ProductGroupset'],
  },
  ItemFrontHub_ItemRearHub: {
    target: 'ProductHub',
    fields: ['ItemFrontHub', 'ItemRearHub'],
  },
  ProductDiscBrakeRotorFront_ProductDiscBrakeRotorRear: {
    target: 'ProductDiscBrake',
    fields: ['ProductDiscBrakeRotorFront', 'ProductDiscBrakeRotorRear'],
  },
  ItemTravelFork_ItemTravelFrame: {
    target: 'SpecTravel',
    fields: ['ItemTravelFork', 'ItemTravelFrame'],
  },
  ProductBrakeLeverDescription_ProductShifter: {
    target: 'SpecLever',
    fields: ['ProductBrakeLeverDescription', 'ProductShifter'],
  },
}

export default compareProductGroupConfig
